import addGetParameters from './addGetParameters';

export default addGetParameters;
